import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { countScheduledPricebooks } from "../../../services";
import { numberWithCommas } from "../../../utils";

interface ScheduledBookBannerProps {
  /** Narrows the list to the books with a schedule waiting. */
  onShowScheduled: () => void;
}

/**
 * The pricebook list's notice that draft applies are set for later days, with the way to list
 * those books. Nothing while none are. Schedules are only set and cancelled on the detail pages,
 * so the count is read once per visit.
 */
export default function ScheduledBookBanner({ onShowScheduled }: ScheduledBookBannerProps) {
  const [scheduledCount, setScheduledCount] = useState<number>(0);

  useEffect(() => {
    let ignore = false;
    const loadCount = async () => {
      try {
        const {
          data: { data },
        } = await countScheduledPricebooks();
        if (!ignore) setScheduledCount(data?.count ?? 0);
      } catch {
        // Swallowed on purpose: an ambient notice must not interrupt the list to say it could
        // not be read. The request suppresses the toast too, and the list itself still works.
      }
    };
    loadCount();
    return () => {
      ignore = true;
    };
  }, []);

  if (scheduledCount <= 0) return null;

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={onShowScheduled}>
          ดูสมุดที่มีตั้งเวลา
        </Button>
      }
    >
      มี {numberWithCommas(scheduledCount)} สมุดราคาที่ตั้งเวลานำร่างไปใช้ไว้
      ระบบนำไปใช้เองตอน 00:01 เวลาไทยของวันมีผล
    </Alert>
  );
}
